export const RESULTS_PER_PAGE = 20;
export const MIN_SEARCH_LENGTH = 3;
export const TEACHERS_PER_PAGE = 1000;
export const STUDENT_PER_PAGE = 2000;
export const TABLE_TYPE = {
  student: 'student',
  parent: 'parent',
};
